import React, { useState } from 'react'
import { TextInputField } from 'evergreen-ui'
import BtnDefault from './BtnDefault'
const EmployeeEmailForm = ({
  emailConfigId, addEmailConfigs, emailConfigData, editEmailConfigs
}) => {
  const [email, setEmail] = useState('')
  const handleChange = ({ target }) => setEmail( target.value )
  const inputEmailValue = emailConfigData ? emailConfigData.ccs : ''

  return (
    <form onSubmit={(e) => {
      e.preventDefault()
    }} >
      <TextInputField
          label='E-mail (Em caso de vários e-mails, separe por vírgula)'
          description=""
          name='email'
          placeholder='E-mail'
          onChange={handleChange}
          disabled={false}
          value={email || inputEmailValue}
      />
      <BtnDefault
          type='button'
          onClick={() => {!!emailConfigId ? addEmailConfigs(emailConfigId, email) : editEmailConfigs(emailConfigData.__id__, email)}}
          appearance='primary' icon={!!emailConfigId ? 'add' : 'edit'}
      > 
        {!!emailConfigId ? 'Adicionar' : 'Editar'}
      </BtnDefault>
    </form>
  )
}

export default EmployeeEmailForm